import React, { Component, Fragment } from 'react'
import {
  Modal,
  ModalBody,
  Button,
} from "reactstrap";
import CheckboxTree from 'react-checkbox-tree';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';

export default class CheckboxTreeList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            listChecked: [],
            confirmChecked: [],
            expanded:  [],
            filterText: null,
            nodesFiltered: [],
            showSuggestions: false,
            isInitData: true,
        };
    }
    toggleDialog = () => {
        let { showSuggestions, confirmChecked, listChecked } = this.state
        if (!showSuggestions) {
            listChecked = this.copyArr(confirmChecked)
        }
        this.setState({ showSuggestions: !showSuggestions, listChecked })
    }
    onSave = () => {
        const { showSuggestions, listChecked } = this.state
        const confirmChecked = this.copyArr(listChecked)
        this.setState({ showSuggestions: !showSuggestions, confirmChecked, isInitData: false })
        if (this.props.onChoice) {
            this.props.onChoice(confirmChecked)
        }
    }
    copyArr = (arr) => {
        let result = []
        for (let index = 0; index < arr.length; index++) {
            const element = arr[index];
            result.push(this.copyEver(element))
        }
        return result
    }
    copyEver = (src, dest = {}) => {
      return Object.assign(dest, src);
    }
    addChecked = (targetNode) => {
        let { listChecked } = this.state;
        var index = listChecked.findIndex(e => e.value == targetNode.value);
        if (index == -1) {
            listChecked.push({ value: targetNode.value, label: targetNode.label, data: targetNode })
        } else {
            listChecked.splice(index, 1);
        }
        return listChecked
    }
    onClick = (targetNode) => {
        if (this.props.isMultiChoice) {
            let listChecked = this.addChecked(targetNode)
            this.setState({listChecked: listChecked });
        } else {
            const result = this.props.nodes.find(x => x.Id == targetNode.value)
            targetNode.data = result
            const listChecked = [targetNode];
            this.setState({listChecked: listChecked }, e => { this.onSave() })
        }
        
    }
    onExpand = (expanded) => {
        this.setState({ expanded });
    }
    onFilterChange = (e) => {
        this.setState({ filterText: e.target.value, showSuggestions: true }, this.filterTree);
    }
    removeNodeChecked = (item) => {
        this.removeNode(item)
        if (this.props.onHandleRemove) {
            this.props.onHandleRemove(item);
        }
    }
    removeNode = (item) => {
        let { listChecked } = this.state;
        if (listChecked && listChecked.length > 0) {
            var indexChecked = listChecked.findIndex(e => e.value === item.value);
            if (indexChecked > -1) {
                listChecked.splice(indexChecked, 1);
            }
            this.setState({ listChecked });
        }
    }
    handleSelectOne = ({target}) => {
        const {nodes} = this.props
        const result = nodes.find(x => x.Id == target.value)
        let listChecked = [{value: 0}]
        if (result) {
            listChecked = [this.dataItem2SelectItem(result)]
        }
        const confirmChecked = this.copyArr(listChecked)
        this.setState({ confirmChecked, isInitData: false })
        if (typeof this.props.onChoice === 'function') {
            this.props.onChoice(confirmChecked, true)
        }
    }
    filterTree = () => {
        const nodes = this.props.nodes.reduce(this.filterNodes, [])
        this.setState({nodesFiltered: this.buildTree(nodes)});
    }
    filterNodes = (filtered, node) => {
        const { filterText } = this.state;
        const children = (node.children || []).reduce(this.filterNodes, []);
        let label = node.Name
        if (node['SubName']) {
            label = `${node.SubName} ${node.Name}`
        }
        if (label.toLocaleLowerCase().indexOf(filterText.toLocaleLowerCase()) > -1 ||
            // Or a children has a matching node
            children.length
        ) {
            filtered.push({ ...node, children });
        }

        return filtered;
    }
    renderNoItem = (item) => {
        if (this.props.formatNoOptionLabel) {
            return this.props.formatNoOptionLabel(item);
        }
        return (
            <em>Không tìm thấy kết quả: <i className="text-danger">{item}</i></em>
        );
    }
    buildTree = (arr, parentId = -1) => {
        var out = [];
        var parrent = [];
        if (arr && arr.length > 0) {
    
          if (parentId == -1) {
            let listIds = arr.map((itemId) => {
              return itemId.Id
            });
            parrent = arr.filter(f => !listIds.includes(f.ParentId));
          }
          else {
            parrent = arr.filter(f => f.ParentId === parentId);
          }
    
          for (var i in parrent) {
            var tmp = this.dataItem2SelectItem(parrent[i])
            var children = this.buildTree(arr, parrent[i].Id)
            if (children.length) {
              tmp.children = children;
            }
            out.push(tmp)
          }
        }
        return out
    }
    dataItem2SelectItem = (data) => {
        var tmp = new Object();
        tmp.title = data["SubName"]
        tmp.label = `${data["Name"]}${tmp.title ? " / " + tmp.title : ""}`
        tmp.value = data.Id
        tmp.key = data.Id
        tmp.data = data
        tmp.showCheckbox = false
        tmp.className = "node-element"
        tmp.showNodeTitles = true
        return tmp
    }
    render() {
        const {
            nodes,
            placeholder,
            className,
            checked
        } = this.props
        
        let {
            showSuggestions,
            filterText,
            expanded,
            listChecked,
            confirmChecked,
            nodesFiltered,
            isInitData,
        } = this.state

        if (!filterText || filterText === '') {
            nodesFiltered = this.buildTree(nodes);
        }
        
        // xu ly re-checked to tree
        if (!confirmChecked || confirmChecked.length == 0) {
            if (isInitData && checked && checked.length > 0) {
                const isArrayObj = typeof checked[0] === 'object'
                let values = []
                if (isArrayObj) {
                    values = checked.map(e => { return e ? e.value : '' })
                } else {
                    values = checked
                }
                const dataChecked = nodes.filter(item => { return values.indexOf(item.Id) > -1 })
                for (let index = 0; index < dataChecked.length; index++) {
                    const element = dataChecked[index];
                    confirmChecked.push(this.dataItem2SelectItem(element))
                }
            }
        }
        const hasChildren = nodes && nodes.length > 1
        let suggestionsListComponent;
        if (showSuggestions) {
            if (nodesFiltered && nodesFiltered.length > 0) {
                suggestionsListComponent = (
                    <ul className="form-control tree-list-suggestion">
                        <li>
                            <CheckboxTree
                                checked={listChecked}
                                expanded={expanded}
                                nodes={nodesFiltered}
                                onClick={this.onClick}
                                onExpand={e => this.onExpand(e)}
                                noCascade={true}
                            />
                        </li>
                    </ul>
                )
            } else {
                if (filterText != '') {
                    suggestionsListComponent = (
                        <div className="tree-list-no-suggestions">
                            {this.renderNoItem(filterText)}
                        </div>
                    );
                }
            }
        }
        const confirmNodesChecked = () => {
            if (!confirmChecked || confirmChecked.length === 0) {
                return null
            }
            return confirmChecked.map((item, index) => {
                return (
                    <li className="treelist-selection__choice" title={item.label} key={index}>
                        {item.label}
                    </li>
                )
            })
        }
        const suggestionChecked = () => {
            if (!listChecked || listChecked.length === 0) {
                return null
            }
            return listChecked.map((item, index) => {
                return (
                    <li className="treelist-selection__choice" title={item.label} key={index}>
                        {item.label}
                        <span onClick={e => this.removeNode(item, e)} className="treelist-selection__choice__remove">
                            <i className="fa fa-close text-white"></i>
                        </span>
                    </li>
                )
            })
        }

        const genItemsSelect = (items, placeholder) => {
            items = items || []
            items.splice(0, 0, { key: 0, value: 0, label: placeholder })
            return items.map((e, index) => {
                return (
                    <option key={index} value={e.value}>
                        {e.label}
                    </option>
                )
            })
        }
        const isShowPlaceHolder = !confirmChecked || confirmChecked.length === 0
        const valueItemDefault = confirmChecked && confirmChecked.length === 1 ? confirmChecked[0].value : 0
        return (
            <div className={`input-group ${className}`}>
                {!hasChildren && (
                    <select className="form-control" value={valueItemDefault} onChange={e => this.handleSelectOne(e)}>
                        {genItemsSelect(nodesFiltered, placeholder)}
                    </select>
                )}
                {hasChildren && (
                    <Fragment>
                    <span className="treelist-container treelist-container--default treelist-container--below treelist-container--focus form-control" >
                        <span className="selection">
                            <span className="treelist-selection treelist-selection--multiple" role="combobox" aria-haspopup="true" aria-expanded="false" >
                                <ul className="treelist-selection__rendered" onClick={e => this.toggleDialog(e)}>
                                    <li className={`treelist-search treelist-search--inline ${!isShowPlaceHolder ? "d-none" : ""}`}>
                                        <input
                                            className="filter-text treelist-search__field"
                                            placeholder={placeholder}
                                            type="text"
                                        />
                                    </li>
                                    {confirmNodesChecked()}
                                </ul>
                            </span>
                        </span>
                        <span className="dropdown-wrapper" aria-hidden="true"></span>
                    </span>
                    <div onClick={e => this.toggleDialog(e)} className="input-group-append cursor-hand"><span className="input-group-text"><i className="icon-arrow-down"></i></span></div>
                    <Modal isOpen={this.state.showSuggestions} toggle={e => this.toggleDialog(e)} className="modal-lg" contentClassName="modal-content-fit-height" modalClassName={"modal-fit"}>
                        <ModalBody>
                            <span className="treelist-container treelist-container--default treelist-container--below treelist-container--focus form-control" >
                                <span className="selection">
                                    <span className="treelist-selection treelist-selection--multiple" role="combobox" aria-haspopup="true" aria-expanded="false" >
                                        <ul className="treelist-selection__rendered">
                                            <li className={`treelist-search treelist-search--inline`}>
                                                <input
                                                    className="filter-text treelist-search__field"
                                                    placeholder={placeholder}
                                                    type="text"
                                                    value={filterText || ''}
                                                    onChange={e => this.onFilterChange(e)}
                                                />
                                            </li>
                                            {suggestionChecked()}
                                        </ul>
                                    </span>
                                </span>
                                <span className="dropdown-wrapper" aria-hidden="true"></span>
                            </span>
                            {suggestionsListComponent}
                            <div className="row col-sm-12">
                                <div className="btn-group float-right" role="group">
                                    <Button className="mr-1" color="primary" onClick={e => this.onSave(e)}><i className="fa fa-check"></i>&nbsp;Chọn</Button>
                                    <Button className="mr-1" color="secondary" onClick={e => this.toggleDialog(e)}><i className="fa fa-close"></i>&nbsp;Huỷ</Button>
                                </div>
                            </div>
                        </ModalBody>
                    </Modal>
                    </Fragment>
                )}
                </div>

        );
    }
}


// WEBPACK FOOTER //
// ./src/views/controls/_CheckboxTreeList.js